import {
    addOWAConnectedAccount,
    removeOWAConnectedAccount,
    updateOWAConnectedAccountToken,
    setAccountStoreInitialized,
} from '../actions';
import { mutator } from 'satcheljs';
import getStore from '../store';
import addSeconds from 'owa-datetime/lib/owaDate/addSeconds';
import { now } from 'owa-datetime';

mutator(addOWAConnectedAccount, ({ account }) => {
    getStore().accountsMap.set(account.primarySmtpAddress, account);
});

mutator(setAccountStoreInitialized, ({ initialized }) => {
    getStore().isAccountsStoreInitialized = initialized;
});

mutator(removeOWAConnectedAccount, ({ primarySmtpAddress: primarySmtpAddress }) => {
    getStore().accountsMap.delete(primarySmtpAddress);
});

mutator(
    updateOWAConnectedAccountToken,
    ({
        primarySmtpAddress: primarySmtpAddress,
        accountToken: accountToken,
        accountTokenExpiresIn: accountTokenExpiresIn,
    }) => {
        const connectedAccount = getStore().accountsMap.get(primarySmtpAddress);
        connectedAccount.token = accountToken;
        connectedAccount.tokenExpiry = addSeconds(now(), parseInt(accountTokenExpiresIn));
    }
);
